import * as React from 'react';
import * as classNames from "classnames";
import './InstitutionsPage.scss';
import { match } from "react-router";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import { routerActions } from 'react-router-redux';
import { Location, History } from "history";
import ReactSelectClass from "react-select";
import ReactTable, { Column, RowInfo } from 'react-table';
import * as ReactTooltip from 'react-tooltip';
import Alert from 'react-s-alert';
import { DefaultLayout, RestrictedLayout, UnrestrictedLayout, SubMenu } from "../../../components/layouts/index";
import * as InstitutionActions from '../../../actions/institution';
import * as PagingActions from '../../../actions/pages/pagingPage';
import * as Dtos from '../../../dtos/Tmd.dtos';
import { ITmdState, IFormFilter } from "../../../reducers/index";
import { RequestState } from "../../../enumerations/RequestState";
import { Link } from "../../../components/routing/index";
import { findLookup, generateOptionsFromLookup } from "../../../helpers/lookupHelper";
import { convertToShortDateString, convertToDateTimeString, convertToApproximateDateString } from "../../../helpers/date";
import { FontAwesomeIcon, FontAwesomeIcons } from "../../../constants/fontAwesomeIcons";
import { ILinkProps } from "../../../components/routing/Link";
import { INavItem } from "../../../components/layouts/NavMenu/NavMenu";
import { DEFAULT_PAGE_SIZE, PAGE_SIZE_OPTIONS } from "../../../constants/reactTableConstants";
import { setModalTitle } from "../../../helpers/modalHelper";
import { Modal, NotificationAlert } from "../../../components/common/index";
import * as AuthenticationHelper from '../../../helpers/authentication';
import * as AuthorisationDefinitions from '../../../constants/authorisationDefinitions';
import { ModalSize } from '../../../enumerations/ModalSize';
import { Form, actions, Control } from 'react-redux-form';
import { TextAreaFormInput, FormFilterInput } from '../../../components/form';
import { SettingsSubMenu } from '../../../helpers/subMenuHelper';
interface IInstitutionsPageProps {
  location: Location;
  history: History;

  // From state
  formFilter: IFormFilter;
  formLength: number;
  institutions: Dtos.Institution[];
  loadingInstitutions: boolean;
  loadInstitutionsSuccess: boolean;
  loadInstitutionsFailure: boolean;
  user: Dtos.User;
  permissions?: Dtos.PersonnelTmdPermissions[];
  formRoles?: Dtos.RoleType[];
  pageSize: number;
}
interface IInstitutionsPageActions {
  clearInstitutions: InstitutionActions.IInstitutionClearActionCreator;
  loadInstitutions: InstitutionActions.IInstitutionLoadActionCreator;
  navigate: typeof routerActions.push;
  navigateReplace: typeof routerActions.replace;
  filter: InstitutionActions.IInstitutionFilterActionCreator;
  setPageSize: PagingActions.IPagingPageSizeChangedStateActionCreator;
}
type InstitutionsPageProps = IInstitutionsPageProps & IInstitutionsPageActions;
const tableHeaderClass = "btn btn-primary btn-block rounded-0 p-3 d-flex";
const tableStyleClass: React.CSSProperties = {
  textAlign: "left",
  fontWeight: "bold",
  color: "white",
  cursor: "pointer"
};
class InstitutionsPage extends React.PureComponent<InstitutionsPageProps, any> {
  constructor(props: InstitutionsPageProps) {
    super(props);
    this.clearInstitutions = this.clearInstitutions.bind(this);
  }
  componentDidMount() {
    const {
      loadInstitutions,
      navigate,
      navigateReplace
    } = this.props;
    loadInstitutions();
  }
  componentWillReceiveProps(nextProps: InstitutionsPageProps) {}
  componentDidUpdate(prevProps: InstitutionsPageProps, prevState) {
    const {
      navigateReplace,
      loadInstitutions
    } = this.props;
  }
  componentWillUpdate(nextProps: InstitutionsPageProps) {}
  componentWillUnmount() {
    this.clearInstitutions();
  }
  clearInstitutions() {
    this.props.clearInstitutions();
  }
  showInstitutions(): boolean {
    const {
      loadingInstitutions,
      loadInstitutionsSuccess
    } = this.props;
    if (!loadingInstitutions && loadInstitutionsSuccess) {
      return true;
    }
    return false;
  }
  render() {
    const {
      loadingInstitutions
    } = this.props;
    return <RestrictedLayout loading={loadingInstitutions} permission={Dtos.Permission.InstitutionView} data-sentry-element="RestrictedLayout" data-sentry-component="InstitutionsPage" data-sentry-source-file="InstitutionsPage.tsx">
            {this.renderContent()}
        </RestrictedLayout>;
  }
  renderContent() {
    const {
      institutions,
      loadingInstitutions,
      loadInstitutionsSuccess,
      loadInstitutionsFailure,
      clearInstitutions,
      navigate,
      user,
      formRoles,
      permissions
    } = this.props;
    return <div>
            <div className="row">
                <div className={"col-6 mb-2"}>
                    <h2>Institutions</h2>
                </div>
                <div className="col-6" style={{
          textAlign: 'right'
        }}>
                    <FormFilterInput formFilter={this.props.formFilter} onFilter={e => this.props.filter(e)} />
                    {AuthenticationHelper.hasPermission(permissions, Dtos.Permission.InstitutionCreate) && <Link className={"btn btn-primary"} url={"/institutions/create"}>Create</Link>}
                </div>
            </div>
            {!this.showInstitutions() ? "Loading Institutions" : null}
            {this.showInstitutions() ? <div className="patient-tables mt-2">
                        {this.createTable()}
                    </div> : null}
        </div>;
  }
  createTable() {
    const {
      institutions,
      user,
      pageSize,
      setPageSize
    } = this.props;
    if (!institutions || institutions.length == 0) {
      return <div className="alert alert-info d-flex">
                <div className="mr-2">
                    <FontAwesomeIcon icon={FontAwesomeIcons.Solid.INFO_SQUARE} fixedWidth />
                </div>
                <span>There are currently no institutions to view.</span>
            </div>;
    }
    const showPagination = institutions.length > pageSize;
    return <div className="table-wrapper mb-3">
            <ReactTable data={institutions} pageSizeOptions={PAGE_SIZE_OPTIONS} defaultPageSize={showPagination ? pageSize : institutions.length} pageSize={showPagination ? pageSize : institutions.length} showPagination={showPagination} className="-striped -highlight -clickable mb-3" noDataText="There are currently no institutions to display" resizable={false} onPageSizeChange={val => setPageSize(val)} getTdProps={(state, rowInfo: RowInfo, column, instance) => {
        return {
          onClick: (e, handleOriginal) => {
            const url: string = "/institutions/" + rowInfo.original.id + "/details";
            this.props.navigate(url);
            if (handleOriginal) {
              handleOriginal();
            }
          },
          style: {
            color: rowInfo && rowInfo.original && rowInfo.original.active ? '#212529' : '#9e9e9e'
          }
        };
      }} defaultSorted={[{
        id: "name",
        desc: false
      }]} columns={[{
        id: "id",
        Header: ' ',
        accessor: "id",
        className: "d-flex align-items-center justify-content-center",
        maxWidth: 50,
        Cell: props => <FontAwesomeIcon icon={FontAwesomeIcons.Light.INSTITUTION} fixedWidth />
      }, {
        id: "name",
        Header: 'Name',
        accessor: 'name',
        className: "d-flex align-items-left justify-content-left",
        headerClassName: "text-left"
      }, {
        id: "code",
        Header: 'Code',
        accessor: 'code',
        maxWidth: 90,
        className: "d-flex align-items-left justify-content-left",
        headerClassName: "text-left"
      }, {
        id: "institutionType",
        Header: 'Type',
        accessor: 'institutionType.value',
        maxWidth: 180,
        className: "d-flex align-items-left justify-content-left",
        headerClassName: "text-left"
      }, {
        id: "country",
        Header: 'Country',
        accessor: 'country.value',
        maxWidth: 180,
        className: "d-flex align-items-left justify-content-left",
        headerClassName: "text-left"
      }, {
        id: "state",
        Header: 'State',
        accessor: 'state.value',
        maxWidth: 220,
        className: "d-flex align-items-left justify-content-left",
        headerClassName: "text-left"
      }]} />
        </div>;
  }
}
const mapStateToProps = (state: ITmdState, ownProps: InstitutionsPageProps): IInstitutionsPageProps => {
  let permissions = state.user.userSummary ? state.user.userSummary.permissions : [];
  return {
    history: ownProps.history,
    location: state.routing.location,
    institutions: state.institutions.formFilteredData!,
    formFilter: state.institutions.formFilter,
    formLength: state.institutions.formLength,
    loadingInstitutions: state.institutions.loadState && state.institutions.loadState.status == RequestState.Pending,
    loadInstitutionsSuccess: state.institutions.loadState && state.institutions.loadState.status == RequestState.Success,
    loadInstitutionsFailure: state.institutions.loadState && state.institutions.loadState.status == RequestState.Failure,
    user: state.user.data,
    permissions: permissions,
    formRoles: state.user.formRoles,
    pageSize: state.pagingPage.pageSize
  };
};
const mapDispatchToProps = (dispatch): IInstitutionsPageActions => {
  return {
    navigate: bindActionCreators(routerActions.push, dispatch),
    navigateReplace: bindActionCreators(routerActions.replace, dispatch),
    loadInstitutions: bindActionCreators(InstitutionActions.LoadInstitution, dispatch),
    clearInstitutions: bindActionCreators(InstitutionActions.Clear, dispatch),
    filter: bindActionCreators(InstitutionActions.Filter, dispatch),
    setPageSize: bindActionCreators(PagingActions.PageSizeChanged, dispatch)
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(InstitutionsPage);